class PopoverController {
  private visibleArrow: boolean;
  private isOpen: boolean;
  private anchorId: string;

  $onInit() {
    const smallMediaBreakpoint = 640;

    this.visibleArrow = window.innerWidth > smallMediaBreakpoint;
  }
}

export class PopoverComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-popup/src/components/popover/popover.html';
  public controller: any = PopoverController;
  public controllerAs: string = '$ctrl';
  public transclude: boolean = true;
  public bindings = {
    isOpen: '<',
    anchorId: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/components/popover/popover.ts